var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-actions',[_c('small',{staticClass:"caption"},[_vm._v("* Requerido")])]),(_vm.loading)?_c('v-progress-linear',{attrs:{"color":"blue","indeterminate":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }